import { Autocomplete, AutocompleteRenderInputParams, Popper, PopperProps, TextField, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AutocompleteHighlight } from "../AutocompleteHighlight";
import { managedSurveyAssetType } from "../constants/managedSurveyAssetTypes";
import { AssetTypesDropdownProps } from "./AssetTypesDropdown";

const assetTypes = Object.entries(managedSurveyAssetType).map(([value, label]) => ({ value, label }));

export default function MUIAssetTypesDropdown(props: AssetTypesDropdownProps) {
  const { selectedAssetType, minWidth: width, onAssetTypeChange, error } = props;
  const { t } = useTranslation();
  const theme = useTheme();

  function handleChange(_e: React.SyntheticEvent, value: { value: string; label: string } | null) {
    onAssetTypeChange(value?.value ?? "");
  }

  const CustomPopper = (props: PopperProps) => (
    <Popper {...props} style={{ zIndex: 9999, width: width }} placement="bottom-start" />
  );

  return (
    <Autocomplete
      autoHighlight
      blurOnSelect
      id="assetTypeDropdown"
      value={assetTypes.find((option) => option.value === selectedAssetType) ?? null}
      PopperComponent={CustomPopper}
      options={assetTypes.filter((option) => option.label !== managedSurveyAssetType.Unknown)}
      renderInput={(params: AutocompleteRenderInputParams) => (
        <TextField
          {...params}
          error={!!error}
          helperText={error}
          placeholder={t("common.select") + t("asset.assetType")}
        />
      )}
      renderOption={(props, option, { inputValue }) => (
        <AutocompleteHighlight
          renderProps={props}
          optionLabel={t(`assetTypes.${option.label}`)}
          inputValue={inputValue}
        />
      )}
      size="small"
      sx={{ width: width || 200, bgcolor: theme.palette.primary.contrastText }}
      onChange={handleChange}
      getOptionLabel={(option) => t(`assetTypes.${option.label}`)}
      isOptionEqualToValue={(option, value) => option.value === value.value}
    />
  );
}
